module.exports = __webpack_public_path__ + "img/maingau-logo@2x.d0632cbc.png";